export const formatTripReference = tripOrId => {
    const id = typeof tripOrId === "object" ? tripOrId?.id : tripOrId;
    const numericId = Number(id);

    if (!Number.isFinite(numericId) || numericId <= 0) return "";

    return `MYC${Math.trunc(numericId).toString().padStart(3, "0")}`;
};

export const getTripReference = trip => {
    const generatedRef = formatTripReference(trip);
    const existingRef = trip?.clientReferenceNumber?.toString?.().trim?.();
    return generatedRef || existingRef || "";
};
